import { Close, Search } from "@mui/icons-material";
import { Grid, Typography } from "@mui/material";
import { useCallback, useEffect } from "react";
import { useReducer, useState } from "react";
import { CONTACTS_APIS, DETAILS_APIS, MASTER_DATA_APIS } from "../../../../common/apis";
import Form, { FormActions } from "../../../../components/Form";
import FormFooter from "../../../../components/FormFooter";
import useFetch from "../../../../hooks/useFetch";
import { useToast } from "../../../../rootContext";
import appResources from "../../../../app-resources/en/Resources.json";
import renderCellExpand from "../../../../components/DatatableCellExpand";
import NewDataTable, { NewDataGridAction } from "../../../../components/NewDataTable";

export default function SearchSite({
  actions,
  contactId,
  propId,
  rowSelected,
  selectedUnit,
}) {

  const { showWarningToast } = useToast();
  const { get, post } = useFetch();

  const [sitesData, setSitesData] = useState([]);
  const [data, dispatch] = useReducer(SearchFluidsFilterReducer, searchFilterDefaults);
  const [allProducts, setAllProducts] = useState([]);
  // ProductId: selectedUnit?.ProductId || 0,
  // UseStartsWith: true,
  // Customer: selectedUnit?.Customer,
  useEffect(() => {
    (async function () {
      const response = await get(`${MASTER_DATA_APIS.GET_BY_TYPES}?types=Products`);
      //Products with AllProducts added at 0 index
      const allProd = JSON.parse(JSON.stringify(response.Products));
      if (allProd) {
        allProd.unshift({
          ProductId: 0,
          Product: "All Products",
          Colour: "",
        });
      }
      setAllProducts(allProd || {});
    })();

    if (selectedUnit) {
      dispatch({
        payload: {
          ProductId: selectedUnit?.ProductId,
          Customer: selectedUnit?.Customer,
          UseStartsWith: false,
          _key: Date.now(),
        },
        type: FormActions.LOAD_DATA,
      });
    }
  }, [selectedUnit]);

  const tblOptions = {
    columns: GetColumns(actions),
    dataSource: sitesData,
    getRowId: (originalRow) => originalRow.SiteId,
    enableColumnActions: false,
    sx: { height: "50dvh", },

    muiTableBodyCellProps: ({ cell, column, row, table }) => {
      return {
        sx:
          cell.column.columnDef.accessorKey === "Product" && row.original.Product ? {
            backgroundColor: (row?.original?.ProductColour + "!important") || "",
            color: "white",
            py: 0.25,
            border: "0.5px solid #d0d0d0",
          } : {
            py: 0.25,
            border: "0.5px solid #d0d0d0",
          }
      }
    },

    muiTableBodyProps: {
      sx: (theme) => ({
        '& tr:nth-of-type(odd):not([data-selected="true"]):not([data-pinned="true"]) > td':
          { backgroundColor: "inherit" },
        '& tr:nth-of-type(odd):not([data-selected="true"]):not([data-pinned="true"]):hover > td':
          { backgroundColor: "inherit" },
        '& tr:nth-of-type(even):not([data-selected="true"]):not([data-pinned="true"]) > td':
          { backgroundColor: "#e2f2ff" },
        // backgroundColor: "inherit",//
        '& tr:nth-of-type(even):not([data-selected="true"]):not([data-pinned="true"]):hover > td':
          { backgroundColor: "#e2f2ff" },
      }),
    },

    cellStylingHandler: "productCommonCellColour",
    rowsSelected: function (rows) {
      rowSelected && rowSelected(rows[0]);
    },
  };

  const formActions = {
    clear: function () {
      dispatch({
        payload: {
          ...searchFilterDefaults,
          _key: Date.now(),
        },
        type: FormActions.RESET_FORM,
      });
    },
    search: async function () {
      if (contactId) {
        const tempSitesData = await post(CONTACTS_APIS.SITES_FOR_CONTACT, {
          ...data,
          ContactId: contactId,
          ExcludeScoped: (propId === 2) ? true : false,
          UseStartsWith: data?.UseStartsWith === true ? true : false,
          ShowAll: true,
        });
        if (tempSitesData.length > 0) {
          setSitesData(tempSitesData);
        } else {
          showWarningToast(appResources.NO_MATCHING_SITES_WERE_FOUND_MSG);
          setSitesData(tempSitesData);
        }
      } else {
        const tempSitesData = await post(DETAILS_APIS.SEARCH_SITES, {
          ...data,
        });
        if (tempSitesData?.length > 0) {
          let filteredData = tempSitesData.filter(item => item?.SiteId !== selectedUnit?.SiteId);
          setSitesData(filteredData);
        } else {
          showWarningToast(appResources.NO_MATCHING_SITES_WERE_FOUND_MSG);
          setSitesData(tempSitesData);
        }
      }
    },
  };

  const handleKeyPress = useCallback(
    (event) => {
      if (event.key === "Enter") {
        event.preventDefault();
        if (data?.Customer || data?.Site) {
          formActions?.search();
        }
      }
    }, [data]);

  useEffect(() => {
    document.addEventListener("keyup", handleKeyPress);
    return () => {
      document.removeEventListener("keyup", handleKeyPress);
    };
  }, [handleKeyPress]);

  return (
    <>
      <Grid container minWidth={800}>
        <Grid item xs={12}>
          <Form
            sections={GetFormSections(allProducts)}
            data={data}
            dispatch={dispatch}
            key={data && data._key}
          />
        </Grid>
        <Grid item xs={12} sx={{ ml: 15, mt: -4 }}>
          <FormFooter
            buttons={GetFormButtons(data, formActions)}
            hideDivider
            gmt={0}
          />
        </Grid>
        <Grid item xs={12} sx={{ mt: 2, mb: 2 }}>
          <Typography variant="subtitle2">
            Total Records: <b> {sitesData && sitesData.length}</b>
          </Typography>
          <NewDataTable {...tblOptions} />
        </Grid>
      </Grid>
    </>
  );
}

const GetFormButtons = (data, { clear, search }) => [
  {
    variant: "outlined",
    label: "Clear",
    onClick: clear,
    startIcon: <Close />,
  },
  {
    variant: "contained",
    label: "Search",
    onClick: search,
    disabled: !(data?.Customer || data?.Site),
    startIcon: <Search />,
  },
];

function GetColumns(actions) {
  return [
    {
      header: "Actions",
      size: 60,
      hide: !actions || !actions.length,
      Cell: function ({ row }) {
        return (actions || []).map(function (ac, i) {
          return (
            <NewDataGridAction
              row={row?.original}
              onClick={ac.action}
              label={ac.label}
            // startIcon={ac.startIcon}
            />
          );
        });
      },
    },
    {
      header: "Product",
      accessorKey: "Product",
      size: 90,
    },
    {
      header: "Customer",
      accessorKey: "Customer",
      size: 250,
      Cell: ({ renderedCellValue }) => renderCellExpand({ value: renderedCellValue }),
    },
    {
      header: "Site",
      accessorKey: "Site",
      size: 250,
      Cell: ({ renderedCellValue }) => renderCellExpand({ value: renderedCellValue }),
    },
    {
      header: "Predelivery",
      accessorKey: "Predelivery",
      size: 100,
    },
    {
      header: "Archived",
      accessorKey: "SiteArchived",
      size: 100,
    },
  ];
}

function GetFormSections(allProducts) {
  return [
    {
      xsCol: 12,
      fields: [
        {
          xsCol: 2,
          name: "ProductId",
          label: "Product",
          type: "dropdown",
          required: true,
          selectOptions: (allProducts || []).map((x) => ({
            value: x.ProductId,
            text: x.Product,
          })),
        },
        {
          xsCol: 3,
          name: "Customer",
          label: "Customer",
        },
        {
          xsCol: 3,
          name: "Site",
          label: "Site",
        },
        {
          xsCol: 3,
          name: "UseStartsWith",
          label: "Starts With Search",
          type: "switch",
          alignSelf: "end",
        },
      ],
    },
  ];
}
const searchFilterDefaults = {
  ProductId: 0,
  UseStartsWith: false,
};
function SearchFluidsFilterReducer(state, action) {
  if (action.type === FormActions.INPUT_CHANGED) {
    return { ...state, [action.payload.name]: action.payload.value };
  }
  if (action.type === FormActions.LOAD_DATA) {
    return { ...action.payload };
  }
  if (action.type === FormActions.RESET_FORM) {
    return { ...action.payload };
  }
  return state;
}
